import React from "react"
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import PanelChatElite from "../components/ChatElite/panel/PanelChatElite";
import { CHAT_ELITE_VISIBLE } from "../utilities/chatEliteUsuario";
import { useTranslation } from "react-i18next";
import { FilePenLine, Building2, Wrench, Icon, Boxes, FileChartLine, FileBox, BriefcaseBusiness } from 'lucide-react';
import { houses, toolbox } from '@lucide/lab';
import Inicio from "./pages/admin/Inicio";
import AAFF from "./pages/admin/AAFF";
import NuevoAAFF from "./pages/admin/NuevoAAFF";
import Comunidades from "./pages/admin/Comunidades";
import Comunidad from "./pages/admin/Comunidad";
import Proveedores from "./pages/admin/Proveedores";
import ProveedoresFincas from "./pages/admin/ProveedoresFincas";
/*import ProveedorFinca from "./pages/admin/ProveedorFinca";*/
import NuevoConsultor from "./pages/admin/NuevoConsultor";
import Consultores from "./pages/admin/Consultores";
import AAFFConsultor from "./pages/admin/AAFFConsultor";
import ProveedoresConsultor from "./pages/admin/ProveedoresConsultor";
import NuevoTecnico from "./pages/admin/NuevoTecnico";
import EditarTecnico from "./pages/admin/EditarTecnico";
import Tecnicos from "./pages/admin/Tecnicos";
import AAFFTecnico from "./pages/admin/AAFFTecnico";
import HojasVisita from "./pages/admin/HojasVisita";
import AsignarConsultor from "./pages/admin/AsignarConsultor";
import Proveedor from "./pages/admin/Proveedor";
import AsignarTecnico from "./pages/admin/AsignarTecnico";
import ProveedoresLista from "./pages/admin/ProveedoresLista";
import ProveedorDatos from "./pages/admin/ProveedorDatos";
import Comerciales from "./pages/admin/Comerciales";
import NuevoComercial from "./pages/admin/NuevoComercial";
import AsignarComercial from "./pages/admin/AsignarComercial";
import AAFFComercial from "./pages/admin/AAFFComercial";
import ProveedoresComercial from "./pages/admin/ProveedoresComercial";
import AlertasAAFF from "./pages/admin/AlertasAAFF";
import AlertasProveedores from "./pages/admin/alertasProveedores";
import GestionComunidades from "./pages/admin/GestionComunidades";
import NuevoCentroTrabajo from "./pages/admin/NuevoCentroTrabajo";
import AAFFInformes from "./pages/admin/AAFFInformes";
import Plantillas from "./pages/admin/Plantillas";
import Ventas from "./pages/admin/Ventas";
import CrearVenta from "./pages/general/CrearVenta";
import EditarVenta from "./pages/general/EditarVenta";
import DatosPerfil from "../components/perfil/datosPerfil";
import NuevoComercialCombo from "./pages/admin/NuevoComercialCombo";
import NuevoProveedor from "./pages/admin/NuevoProveedor";
import NuevoDelegacion from "./pages/admin/NuevoDelegacion";
import DelegacionDatos from "./pages/admin/DelegacionDatos";
import TecnicosEquipos from "./pages/admin/TecnicosEquipos";
import NuevoEquipoTecnicos from "./pages/admin/NuevoEquipoTecnicos";
import EditarEquipoTecnicos from "./pages/admin/EditarEquipoTecnicos";

export function RouteBundle() {
  return (
    <Routes>
      <Route path="/chat-elite" element={CHAT_ELITE_VISIBLE ? <PanelChatElite /> : <Navigate to="/" replace />} />
      <Route path="/" element={<Inicio />} />
      <Route path="/aaff" element={<AAFF />} />
      <Route path="/aaff-informes" element={<AAFFInformes />} />
      <Route path="/aaff/nuevo" element={<NuevoAAFF />} />
      <Route path="/aaff/:nif/comunidades" element={<Comunidades />} />
      <Route path="/aaff/:nif/comunidades/:nifFinca" element={<Comunidad />} />
      <Route path="/aaff/:nif/proveedores" element={<Proveedores />} />
      <Route path="/aaff/:nifAAFF/proveedores/:nifProveedor" element={<Proveedor />} />
      <Route path="/aaff/:nifAAFF/comunidades/:nifFinca/proveedores" element={<ProveedoresFincas />} />
      {/*<Route path="/aaff/:nifAAFF/comunidades/:nifFinca/proveedores/:nifProveedor" element={<ProveedorFinca />} />*/}
      <Route path="/aaff/:nif/consultor/:idGroup" element={<AsignarConsultor />} />
      <Route path="/aaff/:nif/tecnico/:idGroup" element={<AsignarTecnico />} />
      <Route path="/aaff/:nif/comercial" element={<AsignarComercial />} />
      <Route path="/consultores" element={<Consultores />} />
      <Route path="/consultores/nuevo" element={<NuevoConsultor />} />
      <Route path="/consultores/:nif/aaff" element={<AAFFConsultor />} />
      <Route path="/consultores/:nifConsultor/aaff/:nifAAFF/proveedores" element={<ProveedoresConsultor />} />
      <Route path="/tecnicos" element={<Tecnicos />} />
      <Route path="/tecnicos/nuevo" element={<NuevoTecnico />} />
      <Route path="/tecnicos/editar/:nif" element={<EditarTecnico />} />
      <Route path="/tecnicos/:nif/aaff" element={<AAFFTecnico />} />
      <Route path="/tecnicos/:nifTecnico/aaff/:nifAAFF/hojas-visita" element={<HojasVisita />} />
      <Route path="/proveedores" element={<ProveedoresLista />} />
      <Route path="/proveedores/nuevo" element={<NuevoProveedor />} />
      <Route path="/proveedores/:nifProveedor" element={<ProveedorDatos />} />
      <Route path="/comerciales" element={<Comerciales />} />
      <Route path="/comerciales/nuevo" element={<NuevoComercial />} />
      <Route path="/comerciales/nuevo-combo" element={<NuevoComercialCombo />} />
      <Route path="/comerciales/:nifComercial/aaff" element={<AAFFComercial />} />
      <Route path="/comerciales/:nifComercial/aaff/:nifAAFF/proveedores" element={<ProveedoresComercial />} />
      <Route path="/alertas-aaff" element={<AlertasAAFF />} />
      <Route path="/alertas-proveedores" element={<AlertasProveedores />} />
      <Route path="/comunidades/:nifFinca/nuevoCentro" element={<NuevoCentroTrabajo />} />
      <Route path="/comunidades" element={<GestionComunidades />} />
      <Route path="/plantillas" element={<Plantillas />} />
      <Route path="/servicios" element={<Ventas />} />
      <Route path="/servicios/create" element={<CrearVenta />} />
      <Route path="/servicios/editar/:ventaId" element={<EditarVenta />} />
      <Route path="/perfil" element={<DatosPerfil />} />
      <Route path="/delegacion/nueva/:id" element={<NuevoDelegacion />} />
      <Route path="/delegacion/:nifDelegacion/:id" element={<DelegacionDatos />} />
      <Route path="/equipos" element={<TecnicosEquipos />} />
      <Route path="/equipos/nuevo-equipo" element={<NuevoEquipoTecnicos />} />
      <Route path="/equipos/editar/:id" element={<EditarEquipoTecnicos />} />
      <Route path="*" element={<Navigate to='/' replace/>}/>
    </Routes>
  )
}

const refrescoLocal = () => {
  localStorage.setItem("hasReloaded", "true");
}

export function MenuLinksClientes(props) {
  const { t } = useTranslation('nav');
  return (
    <>
        <li>
          <NavLink activeclassname="active" to="/aaff" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "",  color: props.showSidebar ? "#33383b" : "#fff"}}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Building2 stroke-width="1.5" alt={t('clients.aaff')} />{t('clients.aaff')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/proveedores" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Wrench stroke-width="1.5" alt={t('clients.suppliers')} />{t('clients.suppliers')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/comunidades" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Icon iconNode={houses} stroke-width="1.5" alt={t('clients.communities')} />{t('clients.communities')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/servicios" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Boxes stroke-width="1.5" width="35px" alt={t('clients.services')} />{t('clients.services')}
            </div>
          </NavLink>
        </li>
    </>
  )
}
export function MenuLinksPersonal(props) {
  const { t } = useTranslation('nav');
  return (
    <>
        <li>
          <NavLink activeclassname="active" to="/consultores" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <FilePenLine stoke-width="1" alt={t('staff.docManagers')} />{t('staff.docManagers')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/comerciales" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <BriefcaseBusiness stroke-width="1.5" alt={t('staff.commercials')} />{t('staff.commercials')}
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink activeclassname="active" to="/tecnicos" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
            <div className="menuBtn" onClick={refrescoLocal}>
              <Icon iconNode={toolbox} stroke-width="1.5" alt={t('staff.technicians')} />{t('staff.technicians')}
            </div>
          </NavLink>
        </li>
    </>
  )
}
export function MenuLinksListado(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/aaff-informes" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <FileChartLine stroke-width="1.5" alt={t('reports.caeReports')} />{t('reports.caeReports')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink activeclassname="active" to="/plantillas" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <FileBox stroke-width="1.5" alt={t('reports.templateManagement')} />{t('reports.templateManagement')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
export function MenuLinks(props) {
  const { t } = useTranslation('nav');
  return (
    <>
      <li>
        <NavLink activeclassname="active" to="/alertas-aaff" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <Building2 stroke-width="1.5" alt={t('alerts.aaffAlerts')} />{t('alerts.aaffAlerts')}
          </div>
        </NavLink>
      </li>
      <li>
        <NavLink activeclassname="active" to="/alertas-proveedores" style={{ display: props.showSidebar ? "flex" : "block", alignItems: props.showSidebar ? "center" : "" }}>
          <div className="menuBtn" onClick={refrescoLocal}>
            <Wrench stroke-width="1.5" alt={t('alerts.supplierAlerts')} />{t('alerts.supplierAlerts')}
          </div>
        </NavLink>
      </li>
    </>
  )
}
